module.exports = __webpack_public_path__ + "static/media/running.699179cf.svg";